import ShareEmail from './ShareEmail';
export default ShareEmail;